import { Fragment, type ReactNode } from 'react';

/**
 * 찾은 낱말 칠하기 (2026-08-18).
 *
 * 검색 결과의 제목에서 검색어와 겹치는 대목만 `<mark>` 로 감싼다. 문자열을 **쪼개서 노드로**
 * 만든다 — `innerHTML` 로 붙이면 남이 쓴 제목이 그대로 실행 가능한 마크업이 된다.
 *
 * 정규식 특수문자(`.`·`(`·`*` 등)가 검색어에 들어와도 깨지지 않게 이스케이프한다.
 */

function escapeRegExp(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function highlightMatch(text: string, query: string): ReactNode {
  const q = query.trim();
  if (!q) return text;

  const re = new RegExp(escapeRegExp(q), 'gi');
  const nodes: ReactNode[] = [];
  let last = 0;
  let m: RegExpExecArray | null;

  while ((m = re.exec(text)) !== null) {
    if (m.index > last) nodes.push(text.slice(last, m.index));
    nodes.push(<mark key={`${m.index}-${m[0]}`} className="bdw-mark">{m[0]}</mark>);
    last = m.index + m[0].length;
    // 빈 일치(빈 문자열 등)로 무한 루프에 빠지지 않게 한 칸 민다.
    if (m[0].length === 0) re.lastIndex += 1;
  }

  if (nodes.length === 0) return text;
  if (last < text.length) nodes.push(text.slice(last));
  return <>{nodes.map((n, i) => <Fragment key={i}>{n}</Fragment>)}</>;
}
